export function isAdministratorGroupMember(userSession) {
  if(userSession === undefined){
    return false;
  }

  const groups = userSession.idToken.payload["cognito:groups"];
  const adminGroups = groups === undefined ? [] : groups.filter(item => item === 'grp_approval_admin-dev');
  if(adminGroups.length){
    return true;
  }else{
    return false;
  }
}

// 自動ログアウトタイマーアウト時間
export const LOGOUT_TIMEOUT = 1000 * 60 * 30;